import axios from "axios";
import { useState, useEffect } from "react";
import ApiUrl from "./../Environment/ApiUrl";
import { useNavigate } from "react-router-dom";
import "../../assets/css/Loader.css";
import { useToast } from "../Toast/ToastContext";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import * as XLSX from "xlsx";

function Loan() {
  const getCurrentDate = () => {
    const today = new Date();
    const year = today.getFullYear();
    const month = String(today.getMonth() + 1).padStart(2, "0");
    const day = String(today.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  };

  // Helper: returns "English / Tamil" or just product name
  const itemLabel = (loanListItem) => {
    if (!loanListItem) return "-";
    const eng = loanListItem.product_name || "";
    const tam = loanListItem.item_name_tamil || "";
    return tam ? `${eng} / ${tam}` : eng || "-";
  };

  // Helper: returns customer name with Tamil
  const customerLabel = (customer) => {
    if (!customer) return "-";
    const eng = customer.name || "";
    const tam = customer.name_tamil || "";
    return tam ? `${eng} / ${tam}` : eng || "-";
  };

  const toast = useToast();
  const navigate = useNavigate();

  const [loanDataGetting, setLoanDataGetting] = useState([]);
  const [responseData, setResponseData] = useState([]);
  const [paymentModal, setPaymentModal] = useState(false);
  const [infoModal, setInfoModal] = useState(false);
  const [closeLoansModal, setCloseLoansModal] = useState(false);
  const [payments, setPayments] = useState([]);
  const [paymentType, setPaymentType] = useState("");
  const [paymentAmount, setPaymentAmount] = useState("");
  const [deleteShowModals, setDeleteShowModals] = useState(false);
  const [getdeleteid, setdeleteid] = useState("");
  const [getdeletename, setdeletename] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [showAllItems, setShowAllItems] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [loanSearchTerm, setLoanSearchTerm] = useState("");
  const [loading, setLoading] = useState(true);
  const [showLoanDropdown, setShowLoanDropdown] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [selectedLoanId, setSelectedLoanId] = useState(null);
  const [actionType, setActionType] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");

  // Pagination states for Closed Loans Modal
  const [closedLoansCurrentPage, setClosedLoansCurrentPage] = useState(1);
  const [closedLoansItemsPerPage, setClosedLoansItemsPerPage] = useState(10);
  const [closedLoansShowAllItems, setClosedLoansShowAllItems] = useState(false);

  const [notifications, setNotifications] = useState([]);

  const [addData, setAddData] = useState({
    loan_id: "",
    customer_id: "",
    name: "",
    name_tamil: "",
    mobile: "",
    payment_date: "",
    amount: "",
    payment_type: "",
    paid: "0.00",
    balance: "0.00",
    net_total: "0.00",
    payment_history: [],
    loan_amount: "0.00",
  });

  const [addLoanPayment, setAddLoanPayment] = useState({
    loan_id: "",
    customer_id: "",
    name: "",
    name_tamil: "",
    mobile: "",
    address: "",
    payment_type: "",
    payment_date: getCurrentDate(),
    amount: "",
    created_by: "",
    created_date: "",
    loan_amount: "0.00",
    paid: "0.00",
    balance: "0.00",
  });

  const handleprint = (id, loan_id) => {
    navigate(`/loan/${loan_id}`);
  };

  const fetchNotifications = async () => {
    try {
      const response = await axios.get(`${ApiUrl}/Api/notification.php`);
      setNotifications(response.data?.data || []);
    } catch (error) {
      console.error("Error fetching notifications:", error.message);
      toast.error("Failed to fetch notifications", 3000, "topRight");
    }
  };

  const checkNotificationStatus = (loanId, buttonValue) => {
    const userId = localStorage.getItem("username");
    return notifications.some(
      (notif) =>
        notif.table_id === loanId.toString() &&
        notif.button_value === buttonValue &&
        notif.status === "accepted" &&
        notif.employe_id === userId &&
        notif.viewed === "false",
    );
  };

  const hasPendingNotification = (loanId, buttonValue) => {
    const userId = localStorage.getItem("username");
    return notifications.some(
      (notif) =>
        notif.table_id === loanId.toString() &&
        notif.button_value === buttonValue &&
        notif.status === "requested" &&
        notif.employe_id === userId &&
        notif.viewed === "false",
    );
  };

  const handleNotificationSubmit = async (e) => {
    e.preventDefault();
    e.stopPropagation();

    if (isSubmitting) return;
    setIsSubmitting(true);

    if (hasPendingNotification(selectedLoanId, actionType)) {
      toast.warning(
        "A pending request for this action already exists!",
        3000,
        "topRight",
      );
      closeNotificationModal();
      return;
    }

    try {
      const userId = localStorage.getItem("username");
      const currentTime = new Date()
        .toISOString()
        .slice(0, 19)
        .replace("T", " ");

      const formData = {
        table_name: "loan",
        table_id: selectedLoanId,
        employe_id: userId || "",
        status: "requested",
        button_value: actionType,
        time: currentTime,
        viewed: "false",
        created_date: currentTime,
        updated_by: userId || "",
        updated_date: currentTime,
      };

      await axios.post(`${ApiUrl}/Api/notification.php`, formData, {
        headers: { "Content-Type": "application/json" },
      });

      toast.success(
        `${actionType} request sent successfully!`,
        3000,
        "topRight",
      );
      closeNotificationModal();
      fetchNotifications();
    } catch (error) {
      console.error("Error submitting notification:", error.message);
      toast.error(
        "Error submitting notification. Please try again.",
        3000,
        "topRight",
      );
    } finally {
      setIsSubmitting(false);
    }
  };

  const openNotificationModal = (id, action) => {
    setSelectedLoanId(id);
    setActionType(action);
    setShowModal(true);
  };

  const closeNotificationModal = () => {
    setShowModal(false);
    setSelectedLoanId(null);
    setActionType("");
    setIsSubmitting(false);
  };

  const fetchProductType = async () => {
    try {
      setLoading(true);
      const response = await axios.get(`${ApiUrl}/Api/loan.php`);
      setLoanDataGetting(response.data?.data || []);
    } catch (error) {
      console.error("Error fetching product types:", error.message);
      setLoanDataGetting([]);
      toast.error("Failed to fetch loan data", 3000, "topRight");
    } finally {
      setTimeout(() => {
        setLoading(false);
      }, 1000);
    }
  };

  const fetchData = async () => {
    try {
      const localRole = localStorage.getItem("role");
      const localUsername = localStorage.getItem("username");
      const response = await axios.get(
        localRole === "Employee"
          ? `${ApiUrl}/Api/loan.php?employee_id=${localUsername}`
          : `${ApiUrl}/Api/loan.php`,
      );
      let data = Array.isArray(response.data)
        ? response.data
        : response.data?.data || [];
      data = data.map((item) => ({
        ...item,
        loan_list: item.loan_list || [],
        loan_payment_history: item.loan_payment_history || [],
        // Ensure customer has name_tamil
        customer: {
          ...item.customer,
          name_tamil: item.customer?.name_tamil || "",
        }
      }));
      setResponseData(data);
    } catch (error) {
      console.error("Error fetching data:", error.message);
      setResponseData([]);
      toast.error("Failed to fetch data", 3000, "topRight");
    } finally {
      setTimeout(() => {
        setLoading(false);
      }, 1000);
    }
  };

  const handlePrint = () => {
    try {
      const printWindow = window.open("", "_blank");
      printWindow.document.write(`
        <html>
          <head>
            <title>Loan List</title>
            <style>
              body { font-family: Arial, sans-serif; margin: 20px; }
              table { width: 100%; border-collapse: collapse; margin-top: 20px; }
              th, td { border: 1px solid #ddd; padding: 8px; text-align: left; }
              th { background-color: #f2f2f2; font-weight: bold; }
              .header { text-align: center; margin-bottom: 20px; }
              .table-secondary { background-color: #e2e3e5; }
              .table-danger { background-color: #f8d7da; }
              .table-info { background-color: #cff4fc; }
            </style>
          </head>
          <body>
            <div class="header"><h2>Loan List</h2></div>
            <table>
              <thead>
                <tr>
                  <th>S.No</th>
                  <th>Loan ID</th>
                  <th>Customer ID</th>
                  <th>Customer Name</th>
                  <th>Loan Date</th>
                  <th>Category</th>
                  <th>Product</th>
                  <th>Amount</th>
                </tr>
              </thead>
              <tbody>
                ${filteredData
                  .map((item, index) => {
                    const userId = localStorage.getItem("username");
                    const notification = notifications.find(
                      (notif) =>
                        notif.table_id === item.id.toString() &&
                        notif.employe_id === userId &&
                        notif.viewed === "false",
                    );
                    let rowClass = "";
                    if (notification) {
                      switch (notification.status) {
                        case "accepted":
                          rowClass = "table-secondary";
                          break;
                        case "rejected":
                          rowClass = "table-danger";
                          break;
                        case "requested":
                          rowClass = "table-info";
                          break;
                      }
                    }
                    const customerDisplay = item.customer 
                      ? (item.customer.name_tamil 
                          ? `${item.customer.name} / ${item.customer.name_tamil}`
                          : item.customer.name)
                      : "-";
                    return `
                      <tr class="${rowClass}">
                        <td>${index + 1}</td>
                        <td>${item.loan_id || ""}</td>
                        <td>${item.customer_id || ""}</td>
                        <td>${customerDisplay}</td>
                        <td>${formatDate(item.loan_date) || ""}</td>
                        <td>${item.loan_list?.[0]?.category || "-"}</td>
                        <td>${itemLabel(item.loan_list?.[0])}</td>
                        <td>${item.loan_amount || ""}</td>
                      </tr>
                    `;
                  })
                  .join("")}
              </tbody>
            </table>
            <p style="margin-top: 20px; text-align: center; color: #666;">
              Total Records: ${
                filteredData.length
              } | Generated on: ${new Date().toLocaleString()}
            </p>
          </body>
        </html>
      `);
      printWindow.document.close();
      printWindow.focus();
      printWindow.print();
      printWindow.close();
      toast.success("Print dialog opened!", 3000, "topRight");
    } catch (error) {
      console.error("Error printing:", error);
      toast.error("Error printing. Please try again", 3000, "topRight");
    }
  };

  const handleCloseLoansClick = () => {
    navigate("/closed-loans");
  };

  const exportPDF = () => {
    try {
      const doc = new jsPDF();
      doc.setFontSize(18);
      doc.text("Loan List", 14, 22);
      doc.setFontSize(10);
      doc.text(`Generated on: ${new Date().toLocaleString()}`, 14, 30);

      const tableColumns = [
        "S.No",
        "Loan ID",
        "Customer ID",
        "Customer Name",
        "Loan Date",
        "Category",
        "Product",
        "Amount",
      ];
      const tableRows = filteredData.map((item, index) => {
        const userId = localStorage.getItem("username");
        const notification = notifications.find(
          (notif) =>
            notif.table_id === item.id.toString() &&
            notif.employe_id === userId &&
            notif.viewed === "false",
        );
        let rowStyle = {};
        if (notification) {
          switch (notification.status) {
            case "accepted":
              rowStyle = { fillColor: [226, 227, 229] };
              break;
            case "rejected":
              rowStyle = { fillColor: [248, 215, 218] };
              break;
            case "requested":
              rowStyle = { fillColor: [207, 244, 252] };
              break;
          }
        }
        const customerDisplay = item.customer 
          ? (item.customer.name_tamil 
              ? `${item.customer.name} / ${item.customer.name_tamil}`
              : item.customer.name)
          : "-";
        return [
          index + 1,
          item.loan_id || "",
          item.customer_id || "",
          customerDisplay,
          formatDate(item.loan_date) || "",
          item.loan_list?.[0]?.category || "-",
          itemLabel(item.loan_list?.[0]),
          item.loan_amount || "",
          rowStyle,
        ];
      });

      autoTable(doc, {
        head: [tableColumns],
        body: tableRows.map((row) => row.slice(0, -1)),
        startY: 35,
        theme: "striped",
        headStyles: {
          fillColor: [71, 71, 71],
          textColor: [255, 255, 255],
          fontSize: 10,
          fontStyle: "bold",
        },
        bodyStyles: {
          fontSize: 9,
          cellPadding: 3,
        },
        margin: { top: 35, right: 14, bottom: 20, left: 14 },
        didParseCell: (data) => {
          if (data.section === "body") {
            const rowIndex = data.row.index;
            const rowStyle =
              tableRows[rowIndex][tableRows[rowIndex].length - 1];
            if (rowStyle) {
              data.cell.styles = { ...data.cell.styles, ...rowStyle };
            }
          }
        },
      });

      const pageCount = doc.internal.getNumberOfPages();
      for (let i = 1; i <= pageCount; i++) {
        doc.setPage(i);
        doc.setFontSize(8);
        doc.setTextColor(150, 150, 150);
        doc.text(
          `Page ${i} of ${pageCount}`,
          doc.internal.pageSize.width - 30,
          doc.internal.pageSize.height - 10,
        );
        doc.text(
          `Total Records: ${filteredData.length}`,
          14,
          doc.internal.pageSize.height - 10,
        );
      }

      doc.save(`Loan_List_${new Date().toISOString().split("T")[0]}.pdf`);
      toast.success("PDF exported successfully!", 3000, "topRight");
    } catch (error) {
      console.error("Error exporting PDF:", error);
      toast.error("Error exporting PDF. Please try again.", 3000, "topRight");
    }
  };

  const copyToClipboard = () => {
    try {
      const headers = [
        "S.No",
        "Loan ID",
        "Customer ID",
        "Customer Name",
        "Loan Date",
        "Category",
        "Product",
        "Amount",
      ];
      const rows = filteredData.map((item, index) => {
        const customerDisplay = item.customer 
          ? (item.customer.name_tamil 
              ? `${item.customer.name} / ${item.customer.name_tamil}`
              : item.customer.name)
          : "-";
        return [
          index + 1,
          item.loan_id || "",
          item.customer_id || "",
          customerDisplay,
          formatDate(item.loan_date) || "",
          item.loan_list?.[0]?.category || "-",
          itemLabel(item.loan_list?.[0]),
          item.loan_amount || "",
        ];
      });

      const csvData = [headers, ...rows]
        .map((row) => row.map((field) => `"${field}"`).join("\t"))
        .join("\n");

      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard
          .writeText(csvData)
          .then(() => {
            toast.success("Data copied to clipboard!", 3000, "topRight");
          })
          .catch((err) => {
            console.error("Clipboard API failed:", err);
            fallbackCopy(csvData);
          });
      } else {
        fallbackCopy(csvData);
      }
    } catch (error) {
      console.error("Unexpected error copying to clipboard:", error);
      toast.error("Error copying data. Please try again.", 3000, "topRight");
    }
  };

  const fallbackCopy = (text) => {
    try {
      const textArea = document.createElement("textarea");
      textArea.value = text;
      textArea.style.position = "fixed";
      textArea.style.top = 0;
      textArea.style.left = 0;
      textArea.style.width = "2em";
      textArea.style.height = "2em";
      textArea.style.padding = 0;
      textArea.style.border = "none";
      textArea.style.outline = "none";
      textArea.style.boxShadow = "none";
      textArea.style.background = "transparent";
      document.body.appendChild(textArea);
      textArea.focus();
      textArea.select();
      const successful = document.execCommand("copy");
      document.body.removeChild(textArea);
      if (successful) {
        toast.success("Data copied to clipboard!", 3000, "topRight");
      } else {
        toast.error("Failed to copy data", 3000, "topRight");
      }
    } catch (err) {
      console.error("Fallback copy failed:", err);
      toast.error("Failed to copy data", 3000, "topRight");
    }
  };

  const exportCSV = () => {
    try {
      const headers = [
        "S.No",
        "Loan ID",
        "Customer ID",
        "Customer Name",
        "Loan Date",
        "Category",
        "Product",
        "Amount",
      ];
      const rows = filteredData.map((item, index) => {
        const customerDisplay = item.customer 
          ? (item.customer.name_tamil 
              ? `${item.customer.name} / ${item.customer.name_tamil}`
              : item.customer.name)
          : "-";
        return [
          index + 1,
          item.loan_id || "",
          item.customer_id || "",
          customerDisplay,
          formatDate(item.loan_date) || "",
          item.loan_list?.[0]?.category || "-",
          itemLabel(item.loan_list?.[0]),
          item.loan_amount || "",
        ];
      });

      const csvContent = [headers, ...rows]
        .map((row) => row.map((field) => `"${field}"`).join(","))
        .join("\n");

      const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
      const link = document.createElement("a");
      const url = URL.createObjectURL(blob);
      link.setAttribute("href", url);
      link.setAttribute(
        "download",
        `Loan_List_${new Date().toISOString().split("T")[0]}.csv`,
      );
      link.style.visibility = "hidden";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      toast.success("CSV exported successfully!", 3000, "topRight");
    } catch (error) {
      console.error("Error exporting CSV:", error);
      toast.error("Error exporting CSV. Please try again.", 3000, "topRight");
    }
  };

  const exportExcel = () => {
    try {
      const headers = [
        "S.No",
        "Loan ID",
        "Customer ID",
        "Customer Name",
        "Loan Date",
        "Category",
        "Product",
        "Amount",
      ];
      const rows = filteredData.map((item, index) => {
        const customerDisplay = item.customer 
          ? (item.customer.name_tamil 
              ? `${item.customer.name} / ${item.customer.name_tamil}`
              : item.customer.name)
          : "-";
        return {
          "S.No": index + 1,
          "Loan ID": item.loan_id || "",
          "Customer ID": item.customer_id || "",
          "Customer Name": customerDisplay,
          "Loan Date": formatDate(item.loan_date) || "",
          Category: item.loan_list?.[0]?.category || "-",
          Product: itemLabel(item.loan_list?.[0]),
          Amount: item.loan_amount || "",
        };
      });

      const ws = XLSX.utils.json_to_sheet(rows);
      const wscols = [
        { wch: 8 },
        { wch: 15 },
        { wch: 15 },
        { wch: 25 },
        { wch: 12 },
        { wch: 15 },
        { wch: 25 },
        { wch: 12 },
      ];
      ws["!cols"] = wscols;

      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, "Loans");
      wb.Props = {
        Title: "Loan List",
        Subject: "Loan Data Export",
        Author: "Loan Management System",
        CreatedDate: new Date(),
      };

      XLSX.writeFile(
        wb,
        `Loan_List_${new Date().toISOString().split("T")[0]}.xlsx`,
      );
      toast.success("Excel exported successfully!", 3000, "topRight");
    } catch (error) {
      console.error("Error exporting Excel:", error);
      toast.error("Error exporting Excel. Please try again.", 3000, "topRight");
    }
  };

  const handlePrevHistory = async (id) => {
    navigate(`/loan-history/${id}`);
  };

  const handleAddLoan = () => {
    navigate("/add-loan");
  };

  const handleUpdate = (id) => {
    const userRole = localStorage.getItem("role");
    // if (userRole === "Employee") {
    if (userRole === "Employee" || userRole === "Manager") {
      if (checkNotificationStatus(id, "Edit")) {
        navigate(`/update-loan/${id}`);
      } else {
        openNotificationModal(id, "Edit");
      }
    } else {
      navigate(`/update-loan/${id}`);
    }
  };

  const handlePaymentTypeChange = (e) => {
    setPaymentType(e.target.value);
  };

  const handlePaymentAmountChange = (e) => {
    const value = e.target.value;
    const loanAmount = parseFloat(addData.loan_amount) || 0;
    const paidAmount = parseFloat(addData.paid) || 0;
    const balance = loanAmount - paidAmount;

    if (value && parseFloat(value) > balance) {
      toast.error(
        `Payment amount cannot exceed remaining balance of ${balance.toFixed(
          2,
        )}`,
        3000,
        "topRight",
      );
      return;
    }
    setPaymentAmount(value);
  };

  const handleAddPayment = () => {
    if (!paymentType || !paymentAmount || parseFloat(paymentAmount) <= 0) {
      toast.error(
        "Please select payment type and enter a valid amount",
        3000,
        "topRight",
      );
      return;
    }

    const loanAmount = parseFloat(addData.loan_amount) || 0;
    const paidAmount = parseFloat(addData.paid) || 0;
    const newPaymentAmount = parseFloat(paymentAmount);
    const balance = loanAmount - paidAmount;

    if (newPaymentAmount > balance) {
      toast.error(
        `Payment amount cannot exceed remaining balance of ${balance.toFixed(
          2,
        )}`,
        3000,
        "topRight",
      );
      return;
    }

    const today = new Date();
    const formattedDate = today.toISOString().split("T")[0];

    const newPayment = {
      loan_id: addData.loan_id,
      payment_date: formattedDate,
      payment_type: paymentType,
      amount: newPaymentAmount.toFixed(2),
      customer_id: addData.customer_id,
    };

    const updatedPayments = [...payments, newPayment];
    setPayments(updatedPayments);

    const totalPaid = updatedPayments.reduce(
      (sum, payment) => sum + parseFloat(payment.amount || 0),
      0,
    );

    setAddData((prev) => ({
      ...prev,
      paid: totalPaid.toFixed(2),
      balance: (loanAmount - totalPaid).toFixed(2),
      payment_history: updatedPayments,
    }));

    setPaymentType("");
    setPaymentAmount("");
  };

  const handleEditPayment = (index) => {
    const paymentToEdit = payments[index];
    setPaymentType(paymentToEdit.payment_type);
    setPaymentAmount(paymentToEdit.amount);

    const updatedPayments = payments.filter((_, i) => i !== index);
    setPayments(updatedPayments);

    const totalPaid = updatedPayments.reduce(
      (sum, payment) => sum + parseFloat(payment.amount || 0),
      0,
    );

    setAddData((prev) => ({
      ...prev,
      paid: totalPaid.toFixed(2),
      balance: (parseFloat(prev.loan_amount) - totalPaid).toFixed(2),
      payment_history: updatedPayments,
    }));
  };

  const handleDeletePayment = (index) => {
    const updatedPayments = payments.filter((_, i) => i !== index);
    setPayments(updatedPayments);

    const totalPaid = updatedPayments.reduce(
      (sum, payment) => sum + parseFloat(payment.amount || 0),
      0,
    );

    setAddData((prev) => ({
      ...prev,
      paid: totalPaid.toFixed(2),
      balance: (parseFloat(prev.loan_amount) - totalPaid).toFixed(2),
      payment_history: updatedPayments,
    }));
  };

  const handleSubmitPayment = async () => {
    try {
      if (payments.length === 0) {
        toast.error(
          "Please add at least one payment before submitting",
          3000,
          "topRight",
        );
        return;
      }

      for (const payment of payments) {
        if (
          !payment.payment_type ||
          !payment.amount ||
          parseFloat(payment.amount) <= 0
        ) {
          throw new Error(
            "Each payment must have a valid payment type and amount",
          );
        }

        const paymentData = {
          loan_id: payment.loan_id,
          payment_date: payment.payment_date,
          payment_type: payment.payment_type,
          amount: parseFloat(payment.amount).toFixed(2),
          customer_id: payment.customer_id,
          created_by: localStorage.getItem("username") || "",
          created_date: new Date().toISOString(),
          updated_by: localStorage.getItem("username") || "",
          updated_date: new Date().toISOString(),
        };

        const response = await axios.post(
          `${ApiUrl}/Api/loan_payment_history.php`,
          paymentData,
          {
            headers: { "Content-Type": "application/json" },
          },
        );

        if (!response.data.status) {
          throw new Error(response.data.message || "Failed to submit payment");
        }
      }

      toast.success("Payments submitted successfully!", 3000, "topRight");
      setPayments([]);
      setPaymentType("");
      setPaymentAmount("");
      setInfoModal(false);
      fetchData();
    } catch (error) {
      console.error(
        "Error submitting payment:",
        error.response?.data || error.message,
      );
      toast.error(
        `Error submitting payment: ${
          error.response?.data?.message || error.message
        }`,
        3000,
        "topRight",
      );
    }
  };

  const formatDate = (dateString) => {
    if (!dateString) return "";
    const date = new Date(dateString);
    if (isNaN(date.getTime())) return dateString;

    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();
    return `${day}-${month}-${year}`;
  };

  const openmodelhistroy = (index) => {
    const selectedLoan = currentItems[index];
    const loanAmount = parseFloat(selectedLoan.loan_amount || 0);
    const paymentHistory = selectedLoan.loan_payment_history || [];
    const paidAmount = paymentHistory.reduce(
      (sum, payment) => sum + parseFloat(payment.amount || 0),
      0,
    );
    const balance = loanAmount - paidAmount;
    setAddData({
      loan_id: selectedLoan.loan_id,
      customer_id: selectedLoan.customer_id,
      name: selectedLoan.customer?.name || "",
      name_tamil: selectedLoan.customer?.name_tamil || "",
      mobile: selectedLoan.customer?.mobile || "",
      net_total: selectedLoan.total_worth || "0.00",
      loan_amount: selectedLoan.loan_amount || "0.00",
      balance: balance.toFixed(2),
      paid: paidAmount.toFixed(2),
      payment_history: paymentHistory,
    });
    setPayments(paymentHistory);
    setInfoModal(true);
  };

  const closePayment = () => setInfoModal(false);

  const openPaymentModal = () => setPaymentModal(true);

  const closePaymentModal = () => {
    setPaymentModal(false);
    setLoanSearchTerm("");
    setShowLoanDropdown(false);
    setAddLoanPayment({
      loan_id: "",
      customer_id: "",
      name: "",
      name_tamil: "",
      mobile: "",
      address: "",
      payment_type: "",
      payment_date: getCurrentDate(),
      amount: "",
      created_by: "",
      created_date: "",
      loan_amount: "0.00",
      paid: "0.00",
      balance: "0.00",
    });
  };

  const openCloseLoansModal = () => {
    setCloseLoansModal(true);
    setClosedLoansCurrentPage(1);
  };

  const closeCloseLoansModal = () => {
    setCloseLoansModal(false);
    setSearchQuery("");
    setClosedLoansCurrentPage(1);
    setClosedLoansShowAllItems(false);
    setClosedLoansItemsPerPage(10);
  };

  const handleOpenModal = (id, customer_id) => {
    const userRole = localStorage.getItem("role");
    // if (userRole === "Employee") {
    if (userRole === "Employee" || userRole === "Manager") {
      if (checkNotificationStatus(id, "Delete")) {
        setdeleteid(id);
        setdeletename(customer_id);
        setDeleteShowModals(true);
      } else {
        openNotificationModal(id, "Delete");
      }
    } else {
      setdeleteid(id);
      setdeletename(customer_id);
      setDeleteShowModals(true);
    }
  };

  const handleCloseModal = () => {
    setDeleteShowModals(false);
    setdeleteid("");
    setdeletename("");
  };

  const handleDelete = async () => {
    try {
      setLoading(true);
      const response = await axios.delete(
        `${ApiUrl}/Api/loan.php/${getdeleteid}`,
      );

      const notification = notifications.find(
        (notif) =>
          notif.table_id === getdeleteid.toString() &&
          notif.button_value === "Delete" &&
          notif.viewed === "false",
      );
      if (notification) {
        const currentTime = new Date()
          .toISOString()
          .slice(0, 19)
          .replace("T", " ");
        const notificationPayload = {
          id: notification.id,
          viewed: "true",
          updated_by: localStorage.getItem("username"),
          updated_date: currentTime,
          table_name: notification.table_name,
          table_id: notification.table_id,
          employe_id: notification.employe_id,
          status: notification.status,
          button_value: notification.button_value,
          time: notification.time,
          created_date: notification.created_date,
        };

        await axios.put(
          `${ApiUrl}/Api/notification.php/${notification.id}`,
          notificationPayload,
          {
            headers: { "Content-Type": "application/json" },
          },
        );
      }

      toast.success("Deleted successfully!", 3000, "topRight");
      handleCloseModal();
      fetchData();
      fetchNotifications();
    } catch (error) {
      console.error("Error deleting data:", error.message);
      toast.error("Failed to delete data", 3000, "topRight");
    } finally {
      setTimeout(() => {
        setLoading(false);
      }, 1000);
    }
  };

  const filteredData = responseData.filter((item) => {
    const searchLower = searchTerm.toLowerCase();
    const customerName = item.customer?.name || "";
    const customerNameTamil = item.customer?.name_tamil || "";
    return (
      item.customer_id?.toLowerCase().includes(searchLower) ||
      customerName.toLowerCase().includes(searchLower) ||
      customerNameTamil.toLowerCase().includes(searchLower) ||
      item.loan_amount?.toString().includes(searchLower) ||
      item.loan_list?.[0]?.category?.toLowerCase().includes(searchLower) ||
      item.loan_list?.[0]?.product_name?.toLowerCase().includes(searchLower) ||
      item.notes?.toLowerCase().includes(searchLower) ||
      item.loan_id?.toLowerCase().includes(searchLower)
    );
  });

  const closedLoans = responseData.filter(
    (item) => item.loan_status === "Close",
  );

  const filteredLoans = loanDataGetting.filter((loan) =>
    loan.loan_id?.toLowerCase().includes(loanSearchTerm.toLowerCase()),
  );

  // Pagination logic for Closed Loans Modal
  const filteredClosedLoans = closedLoans.filter((item) => {
    if (!searchQuery) return true;
    const query = searchQuery.toLowerCase();
    const customerName = item.customer?.name || "";
    const customerNameTamil = item.customer?.name_tamil || "";
    return (
      item.loan_id?.toString().toLowerCase().includes(query) ||
      item.customer_id?.toString().toLowerCase().includes(query) ||
      customerName.toLowerCase().includes(query) ||
      customerNameTamil.toLowerCase().includes(query) ||
      formatDate(item.loan_date)?.toLowerCase().includes(query) ||
      (item.loan_list?.[0]?.category || "").toLowerCase().includes(query) ||
      (item.loan_list?.[0]?.product_name || "").toLowerCase().includes(query) ||
      item.loan_amount?.toString().toLowerCase().includes(query) ||
      formatDate(item.loan_close_date)?.toLowerCase().includes(query)
    );
  });

  const closedLoansTotalItems = filteredClosedLoans.length;
  const closedLoansTotalPages = closedLoansShowAllItems
    ? 1
    : Math.ceil(closedLoansTotalItems / closedLoansItemsPerPage);
  const closedLoansCurrentItems = closedLoansShowAllItems
    ? filteredClosedLoans
    : filteredClosedLoans.slice(
        (closedLoansCurrentPage - 1) * closedLoansItemsPerPage,
        closedLoansCurrentPage * closedLoansItemsPerPage,
      );

  const handleClosedLoansPageChange = (page) => {
    if (page < 1 || page > closedLoansTotalPages) return;
    setClosedLoansCurrentPage(page);
  };

  const handleClosedLoansItemsPerPageChange = (e) => {
    const value = e.target.value;
    if (value === "All") {
      setClosedLoansShowAllItems(true);
      setClosedLoansCurrentPage(1);
    } else {
      setClosedLoansShowAllItems(false);
      setClosedLoansItemsPerPage(Number(value));
      setClosedLoansCurrentPage(1);
    }
  };

  const renderClosedLoansPageNumbers = () => {
    const pages = [];
    const maxVisiblePages = 2;
    let startPage = Math.max(
      1,
      closedLoansCurrentPage - Math.floor(maxVisiblePages / 2),
    );
    let endPage = Math.min(
      closedLoansTotalPages,
      startPage + maxVisiblePages - 1,
    );

    if (endPage - startPage + 1 < maxVisiblePages) {
      startPage = Math.max(1, endPage - maxVisiblePages + 1);
    }

    if (startPage > 1) {
      pages.push(
        <li
          key={1}
          className={`page-item ${closedLoansCurrentPage === 1 ? "active" : ""}`}
        >
          <button
            className="page-link"
            onClick={() => handleClosedLoansPageChange(1)}
          >
            1
          </button>
        </li>,
      );
      if (startPage > 2) {
        pages.push(
          <li key="start-ellipsis" className="page-item disabled">
            <span className="page-link">...</span>
          </li>,
        );
      }
    }

    for (let i = startPage; i <= endPage; i++) {
      pages.push(
        <li
          key={i}
          className={`page-item ${
            closedLoansCurrentPage === i ? "active" : ""
          }`}
        >
          <button
            className="page-link"
            onClick={() => handleClosedLoansPageChange(i)}
          >
            {i}
          </button>
        </li>,
      );
    }

    if (endPage < closedLoansTotalPages) {
      if (endPage < closedLoansTotalPages - 1) {
        pages.push(
          <li key="end-ellipsis" className="page-item disabled">
            <span className="page-link">...</span>
          </li>,
        );
      }
      pages.push(
        <li
          key={closedLoansTotalPages}
          className={`page-item ${
            closedLoansCurrentPage === closedLoansTotalPages ? "active" : ""
          }`}
        >
          <button
            className="page-link"
            onClick={() => handleClosedLoansPageChange(closedLoansTotalPages)}
          >
            {closedLoansTotalPages}
          </button>
        </li>,
      );
    }

    return pages;
  };

  const handleLoanSelection = async (selectedLoan) => {
    try {
      const loanAmount = parseFloat(selectedLoan.loan_amount || 0);
      const paymentHistory = selectedLoan.loan_payment_history || [];
      const paidAmount = paymentHistory.reduce(
        (sum, payment) => sum + parseFloat(payment.amount || 0),
        0,
      );
      const balance = loanAmount - paidAmount;
      setAddLoanPayment({
        ...addLoanPayment,
        loan_id: selectedLoan.loan_id,
        customer_id: selectedLoan.customer_id,
        name: selectedLoan.customer?.name || "",
        name_tamil: selectedLoan.customer?.name_tamil || "",
        mobile: selectedLoan.customer?.mobile || "",
        address: selectedLoan.customer?.address || "",
        loan_amount: selectedLoan.loan_amount || "0.00",
        paid: paidAmount.toFixed(2),
        balance: balance.toFixed(2),
      });
      setLoanSearchTerm(selectedLoan.loan_id);
      setShowLoanDropdown(false);
    } catch (error) {
      console.error("Error selecting loan:", error);
      toast.error("Error selecting loan", 3000, "topRight");
    }
  };

  const handleLoanSearchChange = (e) => {
    const value = e.target.value;
    setLoanSearchTerm(value);
    setShowLoanDropdown(true);

    if (value !== addLoanPayment.loan_id) {
      setAddLoanPayment({
        ...addLoanPayment,
        loan_id: "",
        customer_id: "",
        name: "",
        name_tamil: "",
        mobile: "",
        address: "",
        loan_amount: "0.00",
        paid: "0.00",
        balance: "0.00",
      });
    }
  };

  const handleLoanSearchKeyPress = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      const matchedLoan = loanDataGetting.find(
        (loan) => loan.loan_id?.toLowerCase() === loanSearchTerm.toLowerCase(),
      );
      if (matchedLoan) {
        handleLoanSelection(matchedLoan);
      }
    }
  };

  const handlePaymentModal = async (e) => {
    e.preventDefault();
    try {
      if (
        !addLoanPayment.loan_id ||
        !addLoanPayment.payment_type ||
        !addLoanPayment.amount ||
        parseFloat(addLoanPayment.amount) <= 0
      ) {
        toast.error(
          "Please fill in all required fields: Loan ID, Payment Type, and a valid Amount",
          3000,
          "topRight",
        );
        return;
      }

      const balance = parseFloat(addLoanPayment.balance) || 0;
      const paymentAmount = parseFloat(addLoanPayment.amount);

      if (paymentAmount > balance) {
        toast.error(
          `Payment amount cannot exceed remaining balance of ${balance.toFixed(
            2,
          )}`,
          3000,
          "topRight",
        );
        return;
      }

      const formData = {
        loan_id: addLoanPayment.loan_id,
        customer_id: addLoanPayment.customer_id,
        payment_type: addLoanPayment.payment_type,
        payment_date: getCurrentDate(),
        amount: paymentAmount.toFixed(2),
        created_by: localStorage.getItem("username") || "",
        created_date: new Date().toISOString(),
        updated_by: localStorage.getItem("username") || "",
        updated_date: new Date().toISOString(),
      };

      const response = await axios.post(
        `${ApiUrl}/Api/loan_payment_history.php`,
        formData,
        {
          headers: { "Content-Type": "application/json" },
        },
      );

      if (response.data.status) {
        toast.success("Payment added successfully!", 3000, "topRight");
        setAddLoanPayment({
          loan_id: "",
          customer_id: "",
          name: "",
          name_tamil: "",
          mobile: "",
          address: "",
          payment_type: "",
          payment_date: getCurrentDate(),
          amount: "",
          created_by: "",
          created_date: "",
          loan_amount: "0.00",
          paid: "0.00",
          balance: "0.00",
        });
        setLoanSearchTerm("");
        closePaymentModal();
        fetchData();
      } else {
        throw new Error(response.data.message || "Failed to add payment");
      }
    } catch (error) {
      console.error(
        "Error submitting payment:",
        error.response?.data || error.message,
      );
      toast.error(
        `Error submitting payment: ${
          error.response?.data?.message || error.message
        }`,
        3000,
        "topRight",
      );
    }
  };

  useEffect(() => {
    fetchProductType();
    fetchData();
    fetchNotifications();
    const interval = setInterval(() => {
      fetchData();
      fetchNotifications();
    }, 5000);
    return () => clearInterval(interval);
  }, []);

  const totalItems = filteredData.length;
  const totalPages = showAllItems ? 1 : Math.ceil(totalItems / itemsPerPage);
  const currentItems = showAllItems
    ? filteredData
    : filteredData.slice(
        (currentPage - 1) * itemsPerPage,
        currentPage * itemsPerPage,
      );

  const handlePageChange = (page) => {
    if (page < 1 || page > totalPages) return;
    setCurrentPage(page);
  };

  const handleItemsPerPageChange = (e) => {
    const value = e.target.value;
    if (value === "All") {
      setShowAllItems(true);
      setCurrentPage(1);
    } else {
      setShowAllItems(false);
      setItemsPerPage(Number(value));
      setCurrentPage(1);
    }
  };

  const renderPageNumbers = () => {
    const pages = [];
    const maxVisiblePages = 2;
    let startPage = Math.max(1, currentPage - Math.floor(maxVisiblePages / 2));
    let endPage = Math.min(totalPages, startPage + maxVisiblePages - 1);

    if (endPage - startPage + 1 < maxVisiblePages) {
      startPage = Math.max(1, endPage - maxVisiblePages + 1);
    }

    if (startPage > 1) {
      pages.push(
        <li
          key={1}
          className={`page-item ${currentPage === 1 ? "active" : ""}`}
        >
          <button className="page-link" onClick={() => handlePageChange(1)}>
            1
          </button>
        </li>,
      );
      if (startPage > 2) {
        pages.push(
          <li key="start-ellipsis" className="page-item disabled">
            <span className="page-link">...</span>
          </li>,
        );
      }
    }

    for (let i = startPage; i <= endPage; i++) {
      pages.push(
        <li
          key={i}
          className={`page-item ${currentPage === i ? "active" : ""}`}
        >
          <button className="page-link" onClick={() => handlePageChange(i)}>
            {i}
          </button>
        </li>,
      );
    }

    if (endPage < totalPages) {
      if (endPage < totalPages - 1) {
        pages.push(
          <li key="end-ellipsis" className="page-item disabled">
            <span className="page-link">...</span>
          </li>,
        );
      }
      pages.push(
        <li
          key={totalPages}
          className={`page-item ${currentPage === totalPages ? "active" : ""}`}
        >
          <button
            className="page-link"
            onClick={() => handlePageChange(totalPages)}
          >
            {totalPages}
          </button>
        </li>,
      );
    }

    return pages;
  };

  return (
    <>
      {loading && (
        <div className="loading-overlay">
          <div className="loading-message">
            <div className="loadinggif"></div>
          </div>
        </div>
      )}

      <div className="container-fluid py-3 mb-5">
        <div className="d-flex justify-content-between align-items-center">
          <div className="d-flex justify-content-between mb-3">
            <div className="d-flex ">
              <h6 className="card-title m-2">Loan</h6>
              <button
                className="btn btn-primary btn-sm rounded-3"
                onClick={handleAddLoan}
              >
                Add <span className="ms-2">+</span>
              </button>
              <button
                className="btn btn-success btn-sm mx-2 rounded-3"
                onClick={openPaymentModal}
              >
                Add Payment <span className="ms-2">+</span>
              </button>
              <button
                className="btn btn-danger btn-sm rounded-3"
                onClick={handleCloseLoansClick}
              >
                Closed Loans ({closedLoans.length})
              </button>
            </div>
          </div>
        </div>

        <div className="card shadow">
          <div className="card-body">
            <div className="d-flex flex-column flex-md-row justify-content-between align-items-center ">
              <div className="d-flex">
                <label className="form-label text-dark mt-2">Show : </label>
                <div>
                  <select
                    className="form-control mx-2"
                    onChange={handleItemsPerPageChange}
                    value={showAllItems ? "All" : itemsPerPage}
                  >
                    <option value="All">All</option>
                    {[5, 10, 20, 100, 200, 500, 1000].map((pageSize) => (
                      <option key={pageSize} value={pageSize}>
                        {pageSize}
                      </option>
                    ))}
                  </select>
                </div>
              </div>

              <div className="d-flex justify-content-center">
                <button
                  className="btn btn-sm btn-info text-white mx-1"
                  onClick={handlePrint}
                >
                  Print
                </button>
                <button
                  className="btn btn-sm btn-info text-white mx-1"
                  onClick={exportPDF}
                >
                  PDF
                </button>
                <button
                  className="btn btn-sm btn-info text-white mx-1"
                  onClick={copyToClipboard}
                >
                  Copy
                </button>
                <button
                  className="btn btn-sm btn-info text-white mx-1"
                  onClick={exportCSV}
                >
                  CSV
                </button>
                <button
                  className="btn btn-sm btn-info text-white mx-1"
                  onClick={exportExcel}
                >
                  Excel
                </button>
              </div>

              <div className="search-container">
                <div className="input-group">
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Search"
                    aria-label="Search"
                    value={searchTerm}
                    onChange={(e) => {
                      setSearchTerm(e.target.value);
                      setCurrentPage(1);
                    }}
                  />
                </div>
              </div>
            </div>

            <div className="card tableCard p-2">
              <div className="table-container">
                <table className="table table-layout-fixed w-100">
                  <thead className="bg-light">
                    <tr>
                      <th style={{ width: '6%' }}>S.No</th>
                      <th>Loan ID</th>
                      <th>Customer ID</th>
                      <th>Customer Name</th>
                      <th>Loan Date</th>
                      <th>Category</th>
                      <th>Product</th>
                      <th>Loan Amount (₹)</th>
                      <th>Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    {Array.isArray(currentItems) &&
                      currentItems.map((item, index) => {
                        const userId = localStorage.getItem("username");
                        const notification = notifications.find(
                          (notif) =>
                            notif.table_id === item.id.toString() &&
                            notif.employe_id === userId &&
                            notif.viewed === "false",
                        );
                        let rowClass = "";
                        if (notification) {
                          switch (notification.status) {
                            case "accepted":
                              rowClass = "table-secondary";
                              break;
                            case "rejected":
                              rowClass = "table-danger";
                              break;
                            case "requested":
                              rowClass = "table-info";
                              break;
                          }
                        }
                        const customerDisplay = item.customer 
                          ? (item.customer.name_tamil 
                              ? `${item.customer.name} / ${item.customer.name_tamil}`
                              : item.customer.name)
                          : "-";
                        return (
                          <tr key={index} className={rowClass}>
                            <td>{(currentPage - 1) * itemsPerPage + index + 1}</td>
                            <td>{item.loan_id}</td>
                            <td>{item.customer_id}</td>
                            <td>{customerDisplay}</td>
                            <td>{formatDate(item.loan_date)}</td>
                            <td>{item.loan_list?.[0]?.category || "-"}</td>
                            <td>{itemLabel(item.loan_list?.[0])}</td>
                            <td>{item.loan_amount}</td>
                            <td>
                              <button
                                className="btn btn-sm btn-light me-1"
                                onClick={() => openmodelhistroy(index)}
                              >
                                <i className="fa-solid fa-plus text-success fs-6"></i>
                              </button>
                              <button
                                className="btn btn-sm btn-light me-1"
                                onClick={() => handleUpdate(item.id)}
                              >
                                <i className="fa-solid fa-pen-to-square text-primary fs-6"></i>
                              </button>
                              <button
                                className="btn btn-sm btn-light me-1"
                                onClick={() =>
                                  handleOpenModal(item.id, item.customer_id)
                                }
                              >
                                <i className="fa-solid fa-trash text-danger fs-6"></i>
                              </button>
                              <button
                                className="btn btn-sm btn-light"
                                onClick={() => handlePrevHistory(item.id)}
                              >
                                <i className="fa-solid fa-info text-secondary fs-6"></i>
                              </button>
                              <button
                                className="btn btn-sm btn-light"
                                onClick={() =>
                                  handleprint(item.id, item.loan_id)
                                }
                              >
                                <i className="fa-solid fa-print text-secondary fs-6"></i>
                              </button>
                            </td>
                          </tr>
                        );
                      })}
                  </tbody>
                </table>
              </div>

              <div className="d-flex justify-content-between align-items-center mt-3">
                <span>
                  Showing {currentItems.length} of {totalItems} entries
                </span>
                <nav>
                  <ul className="pagination mb-0">
                    <li
                      className={`page-item ${
                        currentPage === 1 ? "disabled" : ""
                      }`}
                    >
                      <button
                        className="page-link"
                        onClick={() => handlePageChange(currentPage - 1)}
                      >
                        Previous
                      </button>
                    </li>
                    {renderPageNumbers()}
                    <li
                      className={`page-item ${
                        currentPage === totalPages ? "disabled" : ""
                      }`}
                    >
                      <button
                        className="page-link"
                        onClick={() => handlePageChange(currentPage + 1)}
                      >
                        Next
                      </button>
                    </li>
                  </ul>
                </nav>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Delete Confirmation Modal */}
      {deleteShowModals && (
        <div
          className="modal fade show d-block"
          tabIndex="-1"
          style={{ backgroundColor: "rgba(0,0,0,0.5)" }}
        >
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Confirm Delete</h5>
                <button
                  type="button"
                  className="btn-close"
                  onClick={handleCloseModal}
                ></button>
              </div>
              <div className="modal-body">
                <p>
                  Are you sure you want to delete the loan with Customer ID{" "}
                  <strong>{getdeletename}</strong>?
                </p>
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-secondary"
                  onClick={handleCloseModal}
                >
                  Cancel
                </button>
                <button
                  type="button"
                  className="btn btn-danger"
                  onClick={handleDelete}
                >
                  Delete
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Notification Request Modal */}
      {showModal && (
        <div
          className="modal fade show d-block"
          tabIndex="-1"
          style={{ backgroundColor: "rgba(0,0,0,0.5)" }}
        >
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Request {actionType} Permission</h5>
                <button
                  type="button"
                  className="btn-close"
                  onClick={closeNotificationModal}
                ></button>
              </div>
              <div className="modal-body">
                <p>
                  You do not have permission to {actionType.toLowerCase()} this
                  loan. Would you like to send a request to the admin for
                  approval?
                </p>
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-secondary"
                  onClick={closeNotificationModal}
                >
                  Cancel
                </button>
                <button
                  type="button"
                  className="btn btn-primary"
                  onClick={handleNotificationSubmit}
                  disabled={isSubmitting}
                >
                  {isSubmitting ? "Submitting..." : "Send Request"}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Close Loans Modal */}
      {closeLoansModal && (
        <div
          className="modal fade show d-block"
          tabIndex="-1"
          style={{ backgroundColor: "rgba(0,0,0,0.5)" }}
        >
          <div className="modal-dialog modal-xl modal-dialog-centered ">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Closed Loans List</h5>
                <button
                  type="button"
                  className="btn-close"
                  onClick={closeCloseLoansModal}
                ></button>
              </div>

              <div className="modal-body">
                {/* Search Bar and Items Per Page */}
                <div className="d-flex justify-content-between mb-3">
                  <div className="d-flex">
                    <label className="form-label text-dark mt-2 me-2">
                      Show:
                    </label>
                    <select
                      className="form-control"
                      style={{ width: "100px" }}
                      onChange={handleClosedLoansItemsPerPageChange}
                      value={
                        closedLoansShowAllItems
                          ? "All"
                          : closedLoansItemsPerPage
                      }
                    >
                      <option value="All">All</option>
                      {[5, 10, 20, 50, 100].map((pageSize) => (
                        <option key={pageSize} value={pageSize}>
                          {pageSize}
                        </option>
                      ))}
                    </select>
                  </div>
                  <input
                    type="text"
                    className="form-control w-25"
                    placeholder="Search..."
                    value={searchQuery}
                    onChange={(e) => {
                      setSearchQuery(e.target.value);
                      setClosedLoansCurrentPage(1);
                    }}
                  />
                </div>

                {/* Table */}
                <div
                  style={{ maxHeight: "280px", overflowY: "auto" }}
                  className="card"
                >
                  <table className="table table-bordered table-striped w-100">
                    <thead
                      className="bg-light"
                      style={{ position: "sticky", top: 0, zIndex: 2 }}
                    >
                      <tr>
                        <th>S.No</th>
                        <th>Loan ID</th>
                        <th>Customer ID</th>
                        <th>Customer Name</th>
                        <th>Loan Date</th>
                        <th>Category</th>
                        <th>Product</th>
                        <th>Loan Amount (₹)</th>
                        <th className="text-danger">Loan Close Date</th>
                      </tr>
                    </thead>
                    <tbody>
                      {closedLoansCurrentItems.length > 0 ? (
                        closedLoansCurrentItems.map((item, index) => {
                          const customerDisplay = item.customer 
                            ? (item.customer.name_tamil 
                                ? `${item.customer.name} / ${item.customer.name_tamil}`
                                : item.customer.name)
                            : "-";
                          return (
                            <tr key={index}>
                              <td>
                                {(closedLoansCurrentPage - 1) *
                                  closedLoansItemsPerPage +
                                  index +
                                  1}
                              </td>
                              <td>{item.loan_id}</td>
                              <td>{item.customer_id}</td>
                              <td>{customerDisplay}</td>
                              <td>{formatDate(item.loan_date)}</td>
                              <td>{item.loan_list?.[0]?.category || "-"}</td>
                              <td>{itemLabel(item.loan_list?.[0])}</td>
                              <td>{item.loan_amount}</td>
                              <td>{formatDate(item.loan_close_date)}</td>
                            </tr>
                          );
                        })
                      ) : (
                        <tr>
                          <td colSpan="9" className="text-center">
                            No closed loans found
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>

                {/* Pagination Controls */}
                <div className="d-flex justify-content-between align-items-center mt-3">
                  <span>
                    Showing {closedLoansCurrentItems.length} of{" "}
                    {closedLoansTotalItems} entries
                  </span>
                  <nav>
                    <ul className="pagination mb-0">
                      <li
                        className={`page-item ${
                          closedLoansCurrentPage === 1 ? "disabled" : ""
                        }`}
                      >
                        <button
                          className="page-link"
                          onClick={() =>
                            handleClosedLoansPageChange(
                              closedLoansCurrentPage - 1,
                            )
                          }
                        >
                          Previous
                        </button>
                      </li>
                      {renderClosedLoansPageNumbers()}
                      <li
                        className={`page-item ${
                          closedLoansCurrentPage === closedLoansTotalPages
                            ? "disabled"
                            : ""
                        }`}
                      >
                        <button
                          className="page-link"
                          onClick={() =>
                            handleClosedLoansPageChange(
                              closedLoansCurrentPage + 1,
                            )
                          }
                        >
                          Next
                        </button>
                      </li>
                    </ul>
                  </nav>
                </div>
              </div>

              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-secondary"
                  onClick={closeCloseLoansModal}
                >
                  Close
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Payment Modal */}
      {paymentModal && (
        <div
          className="modal fade show d-block"
          tabIndex="-1"
          style={{ backgroundColor: "rgba(0,0,0,0.5)" }}
        >
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Add Payment</h5>
                <button
                  type="button"
                  className="btn-close"
                  onClick={closePaymentModal}
                ></button>
              </div>
              <div className="modal-body">
                <form onSubmit={handlePaymentModal}>
                  <div className="mb-3 position-relative">
                    <label className="form-label">Loan ID</label>
                    <input
                      type="text"
                      className="form-control"
                      value={loanSearchTerm}
                      onChange={handleLoanSearchChange}
                      onKeyPress={handleLoanSearchKeyPress}
                      placeholder="Search Loan ID (Eg:TJL-001)"
                    />
                    {showLoanDropdown && filteredLoans.length > 0 && (
                      <ul
                        className="dropdown-menu show w-100"
                        style={{
                          maxHeight: "200px",
                          overflowY: "auto",
                          position: "absolute",
                          zIndex: 1000,
                        }}
                      >
                        {filteredLoans.map((loan) => (
                          <li
                            key={loan.loan_id}
                            className="dropdown-item"
                            onClick={() => handleLoanSelection(loan)}
                            style={{ cursor: "pointer" }}
                          >
                            {loan.loan_id} - {loan.customer?.name || "Unknown"}
                          </li>
                        ))}
                      </ul>
                    )}
                  </div>
                  <div className="mb-3">
                    <label className="form-label">Customer Name</label>
                    <input
                      type="text"
                      className="form-control"
                      value={
                        addLoanPayment.name_tamil 
                          ? `${addLoanPayment.name} / ${addLoanPayment.name_tamil}`
                          : addLoanPayment.name
                      }
                      readOnly
                    />
                  </div>
                  <div className="mb-3">
                    <label className="form-label">Mobile</label>
                    <input
                      type="text"
                      className="form-control"
                      value={addLoanPayment.mobile}
                      readOnly
                    />
                  </div>
                  <div className="mb-3">
                    <label className="form-label">Address</label>
                    <input
                      type="text"
                      className="form-control"
                      value={addLoanPayment.address}
                      readOnly
                    />
                  </div>
                  <div className="mb-3">
                    <label className="form-label">Payment Type</label>
                    <select
                      className="form-control"
                      value={addLoanPayment.payment_type}
                      onChange={(e) =>
                        setAddLoanPayment({
                          ...addLoanPayment,
                          payment_type: e.target.value,
                        })
                      }
                    >
                      <option value="">Select Payment Type</option>
                      <option value="Cash">Cash</option>
                      <option value="Bank">Bank</option>
                      <option value="UPI">UPI</option>
                    </select>
                  </div>
                  <div className="mb-3">
                    <label className="form-label">
                      Amount (Balance: {addLoanPayment.balance})
                    </label>
                    <input
                      type="number"
                      className="form-control"
                      value={addLoanPayment.amount}
                      onChange={(e) => {
                        const value = e.target.value;
                        const balance = parseFloat(addLoanPayment.balance) || 0;
                        if (value && parseFloat(value) > balance) {
                          toast.error(
                            `Payment amount cannot exceed remaining balance of ${balance.toFixed(
                              2,
                            )}`,
                            3000,
                            "topRight",
                          );
                          return;
                        }
                        setAddLoanPayment({
                          ...addLoanPayment,
                          amount: value,
                        });
                      }}
                      placeholder="Enter Amount"
                    />
                  </div>
                  <div className="modal-footer">
                    <button
                      type="button"
                      className="btn btn-secondary"
                      onClick={closePaymentModal}
                    >
                      Close
                    </button>
                    <button type="submit" className="btn btn-primary">
                      Submit
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Payment History Modal */}
      {infoModal && (
        <div
          className="modal fade show d-block"
          tabIndex="-1"
          style={{ backgroundColor: "rgba(0,0,0,0.5)" }}
        >
          <div className="modal-dialog modal-dialog-centered modal-md">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Payment Details</h5>
                <button
                  type="button"
                  className="btn-close"
                  onClick={closePayment}
                ></button>
              </div>
              <div className="modal-body">
                <div className="row mb-2">
                  <div className="col-md-6 ">
                    <label className="form-label">Loan ID</label>
                    <input
                      type="text"
                      className="form-control"
                      value={addData.loan_id}
                      readOnly
                    />
                  </div>
                  <div className="col-md-6 ">
                    <label className="form-label">Customer ID</label>
                    <input
                      type="text"
                      className="form-control"
                      value={addData.customer_id}
                      readOnly
                    />
                  </div>
                  <div className="col-md-6">
                    <label className="form-label">Customer Name</label>
                    <input
                      type="text"
                      className="form-control"
                      value={
                        addData.name_tamil 
                          ? `${addData.name} / ${addData.name_tamil}`
                          : addData.name
                      }
                      readOnly
                    />
                  </div>
                  <div className="col-md-6 ">
                    <label className="form-label">Mobile</label>
                    <input
                      type="text"
                      className="form-control"
                      value={addData.mobile}
                      readOnly
                    />
                  </div>
                  <div className="col-md-6">
                    <label className="form-label">Loan Amount</label>
                    <input
                      type="text"
                      className="form-control"
                      value={addData.loan_amount}
                      readOnly
                    />
                  </div>
                  <div className="col-md-6 ">
                    <label className="form-label">Paid Amount</label>
                    <input
                      type="text"
                      className="form-control"
                      value={addData.paid}
                      readOnly
                    />
                  </div>
                  <div className="col-md-6">
                    <label className="form-label">Balance Amount</label>
                    <input
                      type="text"
                      className="form-control"
                      value={addData.balance}
                      readOnly
                    />
                  </div>
                  <div className="col-md-6">
                    <label className="form-label">Payment Type</label>
                    <select
                      className="form-control"
                      value={paymentType}
                      onChange={handlePaymentTypeChange}
                    >
                      <option value="">Select Payment Type</option>
                      <option value="Cash">Cash</option>
                      <option value="Bank">Bank</option>
                      <option value="UPI">UPI</option>
                    </select>
                  </div>
                  <div className="col-md-6 ">
                    <label className="form-label">
                      Amount (Balance: {addData.balance})
                    </label>
                    <input
                      type="number"
                      className="form-control"
                      value={paymentAmount}
                      onChange={handlePaymentAmountChange}
                      placeholder="Enter Amount"
                    />
                  </div>
                  <div className="col-md-6 mt-4">
                    <button
                      className="btn btn-primary"
                      onClick={handleAddPayment}
                    >
                      Add Payment
                    </button>
                  </div>
                </div>
                {payments.length > 0 && (
                  <div className="table-responsive">
                    <table className="table table-bordered">
                      <thead>
                        <tr>
                          <th>Payment Date</th>
                          <th>Payment Type</th>
                          <th>Amount</th>
                          <th>Actions</th>
                        </tr>
                      </thead>
                      <tbody>
                        {payments.map((payment, index) => (
                          <tr key={index}>
                            <td>{formatDate(payment.payment_date)}</td>
                            <td>{payment.payment_type}</td>
                            <td>{payment.amount}</td>
                            <td>
                              <button
                                className="btn btn-sm btn-warning mx-1"
                                onClick={() => handleEditPayment(index)}
                              >
                                Edit
                              </button>
                              <button
                                className="btn btn-sm btn-danger"
                                onClick={() => handleDeletePayment(index)}
                              >
                                Delete
                              </button>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                )}
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-secondary"
                  onClick={closePayment}
                >
                  Close
                </button>
                <button
                  type="button"
                  className="btn btn-primary"
                  onClick={handleSubmitPayment}
                >
                  Submit Payments
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default Loan;